import React from 'react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
import { KARITO_PHOTO } from '../data/content';
export function About() {
  return <Section emoji="🏥" eyebrow="About" title="About Dr. Karito" dark data-id="element-18" data-mp="2ptbjuj1kg7gt">
      <div className="overflow-hidden rounded-3xl border border-white/10 bg-white/[0.04]" data-id="element-19" data-mp="2tripoiuhrod8">
        <img src={KARITO_PHOTO} alt="Dr. Karito, physician and creator of the GLP-1 Clinical Pathway" className="h-64 w-full object-cover object-top sm:h-80" loading="lazy" data-id="element-20" data-mp="2ysy9k7kxnou1" />
        <div className="p-5 sm:p-6" data-id="element-21" data-mp="38o8bywf8ty8c">
          <p className="font-display text-xl font-black leading-snug text-teal-400 sm:text-2xl" data-id="element-22" data-mp="3dgjbvz9zhk0w">
            To give physicians back their clinical confidence.
          </p>
          <div className="mt-4 space-y-3 text-[14.5px] leading-relaxed text-white/75 sm:text-base" data-id="element-23" data-mp="3hkham8vecstf">
            <p data-id="element-24" data-mp="3mfwnoylkykos">
              In a field evolving as fast as GLP-1 therapy, most doctors are left navigating
              uncertainty — unsure about patient selection, dosing, or managing adverse events.
            </p>
            <p data-id="element-25" data-mp="2gse50e2u4f2s">
              The GLP-1 Clinical Pathway™ is the system Dr. Karito wishes existed when starting
              out: a clear, structured, evidence-based roadmap for real clinical practice.
            </p>
          </div>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-md" data-id="element-26" data-mp="27tal57vufvn8">
        <CTAButton label="I want that confidence" variant="light" data-id="element-27" data-mp="34i8csh8ardg6" />
        <p className="mt-3 text-center text-[11px] font-medium text-white/60" data-id="element-28" data-mp="34jjgkh1qsl7a">
          One-time payment · Lifetime access
        </p>
      </div>
    </Section>;
}